import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const ImportBody = styled.div`
    font-size: 14px;
`
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
`

export const ImportFooter = styled(Modal.Footer)`
    .importLabel {
        font-size: 15px;
        cursor: pointer;
        color: var(--gray-0);

        padding: 8px 12px;

        .file-input {
            display: none;
        }
    }

    .btn.btn-primary {
        &.no-pad {
            padding: 0;
        }
    }
`
